import { gql, useQuery } from '@apollo/client';
import * as React from 'react';

import {
  EventAudienceGroupName_Group,
  EventAudienceGroupName_GroupVariables,
} from './graphql-types/EventAudienceGroupName_Group';

import { EventAudienceLink } from '../EventAudienceLink';

const GROUP = gql`
  query EventAudienceGroupName_Group($input: GroupInput!) {
    group(input: $input) {
      result {
        _id
        name
      }
    }
  }
`;

export const EventAudienceGroupName: React.FC<{
  groupId: string;
  isAdminRoute?: boolean;
}> = (props) => {
  const query = useQuery<
    EventAudienceGroupName_Group,
    EventAudienceGroupName_GroupVariables
  >(GROUP, {
    variables: { input: { _id: props.groupId } },
  });

  return (
    <EventAudienceLink
      to={
        props.isAdminRoute
          ? `/admin/community/groups/${props.groupId}/settings`
          : `/community/groups/${props.groupId}/activity`
      }
    >
      {query.data?.group.result?.name}
    </EventAudienceLink>
  );
};
